var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"bottom":"","color":_vm.color,"open-on-click":"","open-on-hover":false},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('v-hover',{scopedSlots:_vm._u([{key:"default",fn:function(ref){
var hover = ref.hover;
return [_c('VBtn',_vm._g(_vm._b({staticClass:"p2-help-btn mr-2 mb-1 mt-0",attrs:{"ripple":false,"icon":"","small":""},on:{"click":on.click}},'VBtn',attrs,false),on),[_c('CustomIcon',{staticClass:"p2-round-icon",attrs:{"size":_vm.iconSize,"icon":hover ? _vm.iconHover : _vm.icon}})],1)]}}],null,true)})]}}])},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }